module.exports = __webpack_public_path__ + "media/images/games/35gender/marchingband-c240618f7ed23e9c68110ba79775f847.png";